<template>
    <v-progress-circular
        indeterminate
        :aria-label="label"
        :color="color"
        :size="size"
        :width="width"
    />
</template>

<script lang="ts" setup>
defineProps<{
    label: string;
    color?: string;
    size?: string | number;
    width?: string | number;
}>();
</script>
